export function buildAddressQueryParams(address, limit) {
  var line1 = address.line1,
      city = address.city,
      state = address.state,
      zip = address.zip;
  var queryParams = "line1=" + line1;
  if (city) queryParams += "&city=" + city;
  if (state) queryParams += "&state=" + state;
  if (zip) queryParams += "&zip=" + zip;
  if (limit) queryParams += "&limit=" + limit;
  return queryParams;
}
export function filterAddressField(text) {
  return text.replace(/[^a-z A-Z 0-9 \- \\ # .]/g, '');
}
export function filterZipField(text) {
  return text.replace(/[^0-9 /-]/g, '');
}
export function isQualifiedAutosuggestSearch(filteredInput, lastFetchValue) {
  var firstSpaceIndex = filteredInput.indexOf(' ');
  if (firstSpaceIndex === -1) return false;
  if (filteredInput[filteredInput.length - 1] === ' ' && filteredInput.trim() === lastFetchValue) return false;
  if (filteredInput === lastFetchValue) return false;
  return true;
}
export function checkIfAddressIsReadyForVerification(address) {
  var line1 = address.line1,
      city = address.city,
      state = address.state,
      zip = address.zip;
  var firstSpaceIndex = line1.indexOf(' ');
  if (firstSpaceIndex !== -1 && line1.substr(firstSpaceIndex + 1, line1.length).length < 3) return false;
  if (city.length < 3) return false;
  if (state === null) return false;
  if (zip.length < 5 || !/^[0-9]{5}(?:-[0-9]{4})?$/.test(zip)) return false;
  return true;
}